import { render, staticRenderFns } from "./SegmentedTrendsInflowTable.vue?vue&type=template&id=53c8fe8e&scoped=true"
import script from "./SegmentedTrendsInflowTable.vue?vue&type=script&lang=ts"
export * from "./SegmentedTrendsInflowTable.vue?vue&type=script&lang=ts"
import style0 from "./SegmentedTrendsInflowTable.vue?vue&type=style&index=0&id=53c8fe8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c8fe8e",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/segmented-trends/segmented-trends-inflow-table.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fsegmented-trends%2FSegmentedTrendsInflowTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports